<template>
  <div id="timeline" class="w-100">
    <div v-if="cargando" class="cargando">
      <v-progress-circular indeterminate color="#2562a4"></v-progress-circular>
    </div>
    <div v-else>
      <template v-if="Object.keys(datos).length > 0">
        <div class="timeline mt-3">
          <ul>
            <div v-for="(dato, index) in Object.keys(datos)" :key="index">
              <div :class="{ actual: meses[new Date(dato).getMonth()] + ' ' + new Date(dato).getDate() + ' ' + new Date(dato).getYear() == meses[new Date().getMonth()] + ' ' + new Date().getDate() + ' ' + new Date().getYear() }">
                <h1>{{ meses[new Date(dato).getMonth()] + ' ' + new Date(dato).getDate() + ' ' + diasemana[new Date(dato).getDay()] }}</h1>
                <li class="visible" v-for="(elemento, posicion) in Object.values(datos)[index]" :key="posicion" :class="{ par: elemento.x % 2 == 0 }">
                  <div class="triangulo">
                    <div></div>
                  </div>
                  <div class="datoslista elevation-9">
                    <div>
                      <p>{{ elemento.mstTitulo }}</p>
                      <span>{{ elemento.mstDesc }}</span>
                    </div>
                    <v-img v-if="elemento.mstImagen != null" max-height="650" max-width="650" v-bind:src="`data:image/jpeg;base64,${elemento.mstImagen}`" class="mt-3 mx-auto"> </v-img>
                  </div>
                </li>
              </div>
            </div>
          </ul>
        </div>
      </template>
      <template v-else>
        <v-alert :value="true" type="primary" class="mx-5 primary-color" outline>No hay eventos </v-alert>
      </template>
    </div>
  </div>
</template>
<script>
import { TimelineApiService } from '@/api/TimelineApiService';
const timelineApi = new TimelineApiService();

export default {
  data() {
    return {
      //Generar los datos de la línea de tiempo
      datos: [],
      meses: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      diasemana: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sabado'],
      cargando: false,
    };
  },
  mounted() {
    this.cambioTitulo();
  
    //Cuando se realiza el scrool
    document.getElementById('timeline').addEventListener('scroll', this.deleteoraddclass);

    this.getTimeLine();
  },
  methods: {
    cambioTitulo() {
      this.$store.state.tituloIcono = '<i class="icon-flickr2"></i>';
      this.$store.state.titulo = 'TimeLine';
    },
    //Método para comprobar en los datos de la ventana
    comprobarventana(elemento) {
      let dato = elemento.getBoundingClientRect();
      return dato.top >= -150 && dato.bottom <= window.innerHeight + 300;
    },
    //Método para añadir una clase o quitarla
    deleteoraddclass() {
        let elementoslista = document.querySelectorAll('.timeline li');
        for (var i = 0; i < elementoslista.length; i++) {
            if (this.comprobarventana(elementoslista[i])) {
                elementoslista[i].classList.add('visible');
                elementoslista[i].classList.remove('novisible');
            } else {
                elementoslista[i].classList.remove('visible');
                elementoslista[i].classList.add('novisible');
            }
        }
    },
    //Metodo para sacar la información de la bd
    getTimeLine() {
        this.cargando = true;
        timelineApi.getAllTimeline().then((data) => {
            this.cargando = false;
            let contador = 0;
            const groupBy = (key) => (array) =>
            array.reduce((objectsByKeyValue, obj) => {
                const value = obj[key];
                obj.x = contador++;
                objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
                return objectsByKeyValue;
            }, {});

            const groupByFecha = groupBy('mstFecha');
            this.datos = groupByFecha(data);
            this.deleteoraddclass();
        });
    },
  },
};
</script>
